import { useSyncExternalStore } from 'react'
import { profileStorage } from '@/services/tokenStorage'
import { CHI_NHANH_CHANGED_EVENT } from '@/utils/changeBranchSession'

const readChiNhanhId = (): number | null => {
  const p = profileStorage.getProfile() as { chiNhanh?: { id?: number | string } } | null
  const id = Number(p?.chiNhanh?.id)
  return Number.isFinite(id) && id > 0 ? id : null
}

const subscribe = (cb: () => void) => {
  window.addEventListener(CHI_NHANH_CHANGED_EVENT, cb)
  return () => window.removeEventListener(CHI_NHANH_CHANGED_EVENT, cb)
}

/** Id chi nhánh đang đứng (theo profile); re-render khi đổi chi nhánh không reload. */
export function useCurrentChiNhanhId(): number | null {
  return useSyncExternalStore(subscribe, readChiNhanhId, readChiNhanhId)
}
